import React, { FC } from 'react'
import './SectionElement.css'
import classNames from '../../../node_modules/classnames/index';

interface AvailabilityElement {
    href: string;
    src: string;
    alt: string;
}
interface MainImage {
    src: string;
    alt: string;
}
interface SectionElementProps {
    title: string;
    subtitle?: string;
    description: string;
    mainImage: MainImage;
    availabilityElements?: Array<AvailabilityElement>;
    isGreyBackground?: boolean;
}

const SectionElement: FC<SectionElementProps> = ({title, subtitle, description, mainImage, availabilityElements, isGreyBackground = false}) => {
    const {src, alt} = mainImage;
    const elementClassName = classNames('element', { grey_element: isGreyBackground });

    return (
        <div className={ elementClassName }>
            <div className="element_image_and_platforms">
                <img className="element_img" width="80px" { ...{src, alt} }/>
                {
                    availabilityElements && (
                        <div className="element_availability_platforms">
                            { 
                                availabilityElements.map(( {href, src, alt}: AvailabilityElement) =>
                                    <a { ...{href} }><img width="30px" src={src} { ...{alt} }/></a>)
                            }
                        </div>)
                }
            </div>
            <div className="element_info">
                <div className="element_title">
                    { title }
                </div>
                <div className="element_description">
                    { subtitle }
                </div>
                <div dangerouslySetInnerHTML={{ __html: description }} className={"element_description"} />
            </div>
        </div>
    )
}

export { SectionElement, SectionElementProps }
